// src/pages/usa/OregonCoast.js
import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../components/affiliate/AffiliateBooking";   // ⭐ REQUIRED
import AffiliateExpedia from "../../components/affiliate/AffiliateExpedia";   // ⭐ REQUIRED
import AffiliateTrip from "../../components/affiliate/AffiliateTrip";   // ⭐ REQUIRED

import { useNavigate, useLocation } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Oregon Coast ALWAYS goes back to Oregon map
export const backRoute = "/map/oregon";

export default function OregonCoast() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { hash } = useLocation();   // ⭐ REQUIRED for hash scrolling

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__oregonCoastBackRouteSet) {
      window.__oregonCoastBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  // ⭐ Smooth scroll to section when hash is present
  useEffect(() => {
    if (!hash) return;

    // Wait for DOM to finish rendering
    setTimeout(() => {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 50);
  }, [hash]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Oregon</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Oregon / The Coast Drive</h2>


           <p>
  My entire trip through Oregon was incredible from start to finish. Every place I visited felt special. 
  The coast drive is one of the most beautiful drives I’ve ever done — the views, the nature, the hidden gems, 
  the lighthouses, and the waterfalls are all unforgettable. Oregon is a state that truly has it all. 
  I started early in the morning from Portland, drove all the way to Tunnel Beach, and from there continued 
  down the entire coastal road until I reached Heceta Lighthouse. After that, I made the long drive back to Portland. 
  It was a long day, but absolutely worth it.
</p>
<p>
  There’s still so much more to explore — both north of Tunnel Beach and south of Heceta. I’m saving
  those for my next trip to Oregon, hopefully with more time so I can explore even more of the coast.
  In this Map Page, I added pins for the places I visited during the drive. These coastal pins all open
  the same description page.
</p>



            {/* GETTING THERE */}
            <h3>🚗 Getting There</h3>

            <p>
              Getting to Oregon depends on where you are coming from and what kind of trip you are
              planning. Some people drive in from neighboring states, especially along the coast
              road, which is full of stunning views and hidden spots.
            </p>

            <p>
              I flew into Portland International Airport (PDX), rented a car through Dollar, and
              stayed at the Best Western Plus Portland Airport Hotel and Suites. It was convenient,
              close to the airport, easy to get in and out, and a great base to start exploring.
             From there, I drove to Tunnel Beach starting at the Best Western Plus near the Portland Airport 
             and took the following in order: Airport Way → I‑205 South → I‑84 West → I‑5 South → I‑405 South →
             US‑26 West → OR‑6 West → OR‑131 West. This route takes you through Portland, across
             the coastal mountains, and finally into the Oceanside/Tunnel Beach area. It’s a
             beautiful drive with smooth transitions between highways.
 
            </p>

            {/* PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

         

           
           
            <ul>
             
              <li>
          <div id="tunnelbeach"> </div>       
  <div className="place-block">
    
    <strong>Tunnel Beach: </strong>
    I started my day early and arrived at Tunnel Beach around 7:00 AM. There were only a few people
    walking around at that time, and the morning was cold and a bit cloudy — not a full sunny day,
    but honestly that made the atmosphere even better. The view was amazing. Walking along the beach,
    listening to the sound of the waves, and feeling the cold (but not burning) wind created a perfect
    coastal scene.
    <br />
    One of the most interesting things about Tunnel Beach is the man‑made tunnel carved directly
    through the rock. It cuts underneath the mountain and connects one side of the beach to the other,
    making the experience even more unique.
    <br />
    <a
      href="https://www.google.com/maps?q=45.463710622383005,-123.9736036690644"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Tunnel Beach
    </a>
  
  </div>
</li>

<li>
   <div id="hungryharbor"> </div>
  <div className="place-block">
    <strong>Hungry Harbor Road: </strong>
    We stopped here mainly to see the impressive Chief Kiawanda Rock, and the stop was absolutely
    worth it. We had to wait a little bit to find a parking spot because the area is really popular,
    but once we got out of the car the views were amazing. The whole place has a lively atmosphere,
    and even though we didn’t stop to eat, the smell of the food from the nearby spots was incredibly
    tempting.
    <br />
    Our plan was to eat later at the 60s Café for dinner — a place I had seen in a video and really
    wanted to try — so we kept moving. But Hungry Harbor Road definitely left a great impression.
    <br />
    <a
      href="https://www.google.com/maps?q=45.21538652309485,-123.97155540372621"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Hungry Harbor Road
    </a>
  </div>
</li>
                 <li>
  <div className="place-block">
    <strong>Big Lot: </strong>
    A small roadside pull‑off along the Oregon Coast that gives you a surprisingly wide and beautiful
    view of the Pacific. It’s not an official viewpoint, but the stop is worth it — the cliffs, the
    waves, and the coastal breeze create a perfect moment to pause between Devils Punch Bowl and
    Yaquina Head.
    <br />
    <a
      href="https://www.google.com/maps?q=44.82961332528653,-124.06483623784096"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 View on Google Maps
    </a>
  </div>
</li>

              <li>
    <div id="devilspunchbowl"> </div>
  <div className="place-block">
    <strong>Devils Punch Bowl: </strong>
    The view here is amazing. Sadly, I didn’t get the chance to explore more — I was trying to find the
    access point to go down into the bowl, but the rain started and I had to head back to my car. Even
    with the weather changing, the place still felt powerful and dramatic.
    <br /><br />
    For anyone visiting: you can only go inside the “bowl” during low tide, and the access is from the
    beach level on the north side. When the tide is high or the waves are strong, the area becomes
    dangerous and completely inaccessible. Most people enjoy it from the upper viewpoint, which is
    still absolutely worth the stop.
    <br />
    <a
      href="https://www.google.com/maps?q=44.74703293009211,-124.06492286458152"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 View on Google Maps
    </a>
  </div>
</li>


              <li>
    <div id="yaquinalighthouse"> </div>
  <div className="place-block">
    <strong>Yaquina Lighthouse: </strong>
    What a great experience I had here. Not only the view of the ocean from the lighthouse area, but
    also the birds gathering on the rocks and the chance to watch the sea lions resting below. The whole
    place feels alive — the sound of the waves, the wind, and the wildlife make it a perfect coastal stop.
    <br /><br />
    Yaquina Head Lighthouse is the tallest lighthouse in Oregon, standing at 93 feet. It was completed
    in 1873 and built to guide ships safely along the rugged coastline. The light originally used a
    first‑order Fresnel lens, which allowed it to shine more than 20 miles out to sea. Today, the
    lighthouse is fully automated but still active, and the surrounding area is protected as the
    Yaquina Head Outstanding Natural Area.
    <br />
    <a
      href="https://www.google.com/maps?q=44.676735738099225,-124.07929494165818"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 View on Google Maps
    </a>
  </div>
</li>


              <li>
    <div id="hecetalighthouse"> </div>
  <div className="place-block">
    <strong>Heceta Lighthouse: </strong>
    This was my last stop of the day, and what I can tell is that the view is amazing from start to
    end. The access to the lighthouse begins at the parking lot next to the beach, and the walk from
    there is easy, refreshing, and shaded by the trees. The distance is about half a mile, and the
    trail is smooth and comfortable to walk.
    <br /><br />
    From the lighthouse, the view is stunning — the cliffs, the ocean, and the sound of the waves make
    you feel relaxed instantly. This time I didn’t have the chance to go inside because it was closed
    to the public, but even from the outside the experience is worth it. I know there are some hidden
    spots around the area for photos and videos, but after a full day of driving, my return to Portland
    had to start at some point.
    <br /><br />
    Heceta Head Lighthouse was completed in 1894 and stands 56 feet tall, but because it sits on a
    205‑foot cliff, its light reaches more than 21 miles out to sea. It uses a first‑order Fresnel lens
    and was built to guide ships along one of the most dangerous stretches of the Oregon Coast. Today,
    it remains an active lighthouse and is one of the most photographed in the entire Pacific Northwest.
    <br /><br />
    Next to the lighthouse is the historic Keeper’s House, built in the same year (1894). It originally
    housed the assistant lighthouse keepers and their families. Today, it operates as the Heceta Head
    Lighthouse Bed & Breakfast, offering ocean‑view rooms and a famous seven‑course breakfast. The house
    is beautifully preserved and still feels connected to the lighthouse’s history.
    <br />
    <a
      href="https://www.google.com/maps?q=44.13718385759406,-124.12782697409865"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 View on Google Maps
    </a>
  </div>
</li>
 </ul>

           
            {/* HIDDEN GEMS */}
            <h3>🌲 Hidden Gems</h3>

<ul>
  <li>
    <div className="place-block">
      <strong>Cannon Beach: </strong>
      One of the most iconic beaches in Oregon, famous for Haystack Rock and its dramatic coastal views.
      A must‑visit spot for photography and sunsets.
      <br />
      <a
        href="https://www.google.com/maps?q=45.88185276705632, -123.96379464378106"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Indian Beach: </strong>
      A quieter, beautiful beach inside Ecola State Park. Great for tide pools, surfing, and peaceful
      coastal views away from the crowds.
      <br />
      <a
        href="https://www.google.com/maps?q=45.92991022033768, -123.97826599807746"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Tillamook Rock Lighthouse: </strong>
      Known as “Terrible Tilly,” this abandoned lighthouse sits on a rock offshore. You can’t visit it,
      but the viewpoint from Ecola State Park is dramatic and unforgettable.
      <br />
      <a
        href="https://www.google.com/maps?q=45.942126649856384, -123.98817088841987"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Thor’s Well: </strong>
      A natural sinkhole that appears to drain the ocean. Best viewed at high tide from a safe distance.
      One of the most unique natural formations on the Oregon Coast.
      <br />
      <a
        href="https://www.google.com/maps?q=44.27836974075084, -124.1131896645918"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Sea Lion Caves: </strong>
      The largest sea cave in the United States, home to wild sea lions and dramatic ocean cliffs. A
      great stop for wildlife lovers.
      <br />
      <a
        href="https://www.google.com/maps?q=44.121869659059314, -124.12693603761429"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Oregon Dunes: </strong>
      A massive stretch of shifting sand dunes — one of the most unique landscapes on the entire coast.
      Perfect for photography, hiking, and off‑road adventures.
      <br />
      <a
        href="https://www.google.com/maps?q=43.71368827555334, -124.1811239446224"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>
</ul>

            {/* PLACES TO STAY */}
            <h3>🛏️ Places to Stay in Oregon</h3>

           <li>
  <div className="place-block">
    <strong>Hallmark Resort & Spa, Cannon Beach: </strong>
    Oceanfront rooms with direct views of Haystack Rock. Highly rated on Booking.com and Expedia.
    Located about 0.8 miles from Cannon Beach.
  </div>
</li>

<li>
  <div className="place-block">
    <strong>Surfsand Resort, Cannon Beach: </strong>
    Beachfront stay with modern rooms and excellent service. Available on Booking.com and Expedia.
    About 1 mile from Cannon Beach and 2 miles from Indian Beach.
  </div>
</li>

<li>
  <div className="place-block">
    <strong>Inn at Cannon Beach: </strong>
    Cozy, quiet, and surrounded by nature. Listed on Booking.com and Expedia.
    About 1.5 miles from Cannon Beach.
  </div>
</li>
<li>
  <div className="place-block">
    <strong>Headlands Coastal Lodge & Spa: </strong>
    Luxury oceanfront lodge with incredible views of Chief Kiawanda Rock. On Booking.com and Expedia.
    About 0.7 miles from Hungry Harbor Road.
  </div>
</li>

<li>
  <div className="place-block">
    <strong>Inn at Cape Kiwanda: </strong>
    Boutique hotel with balconies facing the ocean. Available on Booking.com and Expedia.
    About 0.5 miles from Hungry Harbor Road.
  </div>
</li>

<li>
  <div className="place-block">
    <strong>Pacific City Inn: </strong>
    Budget‑friendly option with clean rooms and easy access to the coast. On Booking.com and Expedia.
    About 1.2 miles from Hungry Harbor Road.
  </div>
</li>
<li>
  <div class="place-block">
    <strong>Hallmark Resort Newport: </strong>
    Oceanfront hotel with sea lion views and great amenities. Listed on Booking.com and Expedia.
    About 2.5 miles from Yaquina Head Lighthouse.
  </div>
</li>

<li>
  <div class="place-block">
    <strong>Inn at Nye Beach: </strong>
    Modern boutique hotel with ocean views and direct beach access. On Booking.com and Expedia.
    About 2.2 miles from Yaquina Head Lighthouse.
  </div>
</li>

<li>
  <div class="place-block">
    <strong>Starfish Point: </strong>
    Spacious condo‑style suites with panoramic ocean views. Available on Booking.com and Expedia.
    Only 1.1 miles from Yaquina Head Lighthouse.
  </div>
</li>
<li>
  <div className="place-block">
    <strong>Heceta Head Lighthouse Bed & Breakfast: </strong>
    Historic keeper’s house from 1894 with ocean‑view rooms and a famous 7‑course breakfast.
    Listed on Booking.com and Expedia. Located right next to the lighthouse (0.1 miles).
  </div>
</li>

<li>
  <div className="place-block">
    <strong>Driftwood Shores Resort & Conference Center: </strong>
    Oceanfront hotel with direct beach access. On Booking.com and Expedia.
    About 8 miles from Heceta Head Lighthouse.
  </div>
</li>

<li>
  <div className="place-block">
    <strong>Old Town Inn, Florence: </strong>
    Clean, comfortable, and close to restaurants and the riverfront. Listed on Booking.com and Expedia.
    About 12 miles from Heceta Head Lighthouse.
  </div>
</li>


            {/* AFFILIATE BLOCK */}
            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                        <div className="affiliate-block">
                          <AffiliateExpedia />
                          <AffiliateBooking />
                          <AffiliateTrip />
                        </div>

            {/* VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>
              I took these videos from the Columbia River Highway, Oregon Coast, and Silver Falls
              State Park. Set the YouTube video quality to high resolution — I hope you enjoy them.
            </p>

            <p>
              <a
                href="https://youtu.be/sKY4QGH-_dc?si=3TuxLtHJJ1lxwWIB"
                target="_blank"
                rel="noopener noreferrer"
              >
                Columbia River Highway
              </a>
              <br />
              <a
                href="https://youtu.be/gnRiwn0G5M0?si=Pe6mMswPuAE0DvOq"
                target="_blank"
                rel="noopener noreferrer"
              >
                Vista House at Crown Point
              </a>
              <br />
              <a
                href="https://youtu.be/RfD-5Sn4mkU?si=JqfA66NOIjw-Vn_E"
                target="_blank"
                rel="noopener noreferrer"
              >
                Heceta Lighthouse
              </a>
              <br />
              <a
                href="https://youtu.be/eBihBb-C72Q?si=5d8e9BAcBVIzR9_E"
                target="_blank"
                rel="noopener noreferrer"
              >
                            Tunnel Beach
              </a>
              <br />
              <a
                href="https://youtu.be/dtBJI2IkvzQ?si=Nc3FDkqjuILq88Zn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Yaquina Lighthouse
              </a>
              <br />
               <a
                href="https://youtu.be/gnRiwn0G5M0?si=eFoVNkSpctkuaDlI"
                target="_blank"
                rel="noopener noreferrer"
              >
                Vista House at Crown Point
              </a>
              <br />
              <a
                href="https://youtu.be/9VtL3hw9HSQ?si=gNw1aZHo-5ACv47y"
                target="_blank"
                rel="noopener noreferrer"
              >
                Silver Falls State Park
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
           
            <a
              href="https://youtu.be/eBihBb-C72Q?si=5d8e9BAcBVIzR9_E"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/oregon/tunnelbeach.jpg"
                alt="Tunnel Beach Video"
              />
            </a>

            <a
              href="https://youtu.be/RfD-5Sn4mkU?si=JqfA66NOIjw-Vn_E"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/oregon/hacetalighthouseg.jpg"
                alt="Heceta Lighthouse Video"
              />
            </a>

            <a
              href="https://youtu.be/dtBJI2IkvzQ?si=Nc3FDkqjuILq88Zn"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/oregon/yaquinalighthouse.jpg"
                alt="Yaquina Lighthouse Video"
              />
            </a>
            
            <img src="/images/usa/oregon/tb.jpg" alt="Tunnel Beach" />
            <img src="/images/usa/oregon/ttb.jpg" alt="Tunnel Beach" />
            <img src="/images/usa/oregon/tunnel.jpg" alt="Tunnel entrance" />
            <img src="/images/usa/oregon/tunnelentrance.jpg" alt="Tunnel entrance" />
            <img src="/images/usa/oregon/coast.jpg" alt="Oregon Coast" />
            <img src="/images/usa/oregon/coast2.jpg" alt="Oregon Coast" />
            <img src="/images/usa/oregon/dpb.jpg" alt="Oregon Coast" />
           <img src="/images/usa/oregon/haceta.jpg" alt="Oregon Coast" />
           <img src="/images/usa/oregon/haceta6.jpg" alt="Oregon Coast" />
           <img src="/images/usa/oregon/haceta3.jpg" alt="Oregon Coast" />
            <img src="/images/usa/oregon/haceta2.jpg" alt="Oregon Coast" />
           <img src="/images/usa/oregon/yaquina.jpg" alt="Yaquina Lighthouse" />
            <img src="/images/usa/oregon/hacetahouse.jpg" alt="Heceta House" />
           <img src="/images/usa/oregon/hungry3.jpg" alt="Chief Kiawanda Rock" />
            <img src="/images/usa/oregon/hungry.jpg" alt="Chief Kiawanda Rock" />
           
            
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      {/* POPUP */}
      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
